import { render } from "./CardThirtyNine.vue?vue&type=template&id=54436617"
import script from "./CardThirtyNine.vue?vue&type=script&lang=js"
export * from "./CardThirtyNine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__